// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* resource hub*/
.resource-hub {
  background: #fff !important;
  padding: 2rem 3rem;
}
.resource-hub .search-container {
  display: flex;
  align-items: center;
  width: 100%;
  border: 0px;
  border-bottom: 1px solid #212529;
  border-radius: 0px;
  padding: 5px;
  margin-bottom: 20px;
  background: transparent;
  height: 60px;
}
.resource-hub .search-container .search-icon {
  padding: 5px;
  background-color: transparent;
  border-radius: 5px 0 0 5px;
  font-size: 20px;
}
.resource-hub .search-container .search-input {
  flex: 1;
  border: none;
  padding: 5px;
  height: 100%;
  font-size: 25px;
  font-weight: 400;
  background: transparent;
  outline: none !important;
}
.resource-hub .search-container .search-button {
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  display: none;
}
.resource-hub .serch-topic-module {
  display: flex;
  flex: 1;
  width: calc(100% - 24px);
  bottom: 0px;
  right: 30px;
  left: 12px;
}
.resource-hub .serch-topic-module .module-wrap {
  flex: 1;
  margin-right: 20px;
}
.resource-hub .serch-topic-module .module-wrap .module-parent {
  width: 100%;
}
.resource-hub .serch-topic-module .module-wrap .module-parent button {
  align-items: center;
  background-color: #ebebed;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-size: 20px;
  height: 100%;
  letter-spacing: -0.1px;
  padding: 26px 32px 27px;
  text-align: left;
  width: 100%;
  border: 0px;
  margin-bottom: 20px;
  font-size: 19px;
  padding: 23px 28px;
  display: flex;
  justify-content: space-between;
}
.resource-hub .serch-topic-module .module-wrap .module-parent:last-child button {
  margin-bottom: 0px;
}
.resource-hub .serch-topic-module .searchbtn-wrap {
  flex: 1;
  width: auto;
  display: flex;
  align-items: end;
  justify-content: flex-start;
}
.resource-hub .serch-topic-module .searchbtn-wrap button {
  width: 80%;
  height: 80px;
  background: rgba(79, 83, 96, 0.8);
  border-radius: 45px;
  color: #fff;
  font-size: 19px;
  border: 0px;
  padding: 23px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.resource-hub .module-details {
  position: fixed;
  width: 100%;
  max-height: 400px;
  display: none;
}
.resource-hub .module-details ul {
  border: 1px solid #c4c5ca;
  display: inline-flex;
  padding: 15px !important;
  flex-wrap: wrap;
  min-width: 100%;
  box-sizing: border-box;
}
.resource-hub .module-details ul li {
  border: 1px solid #ebebed;
  cursor: pointer;
  height: 36px;
  margin: 8px;
  display: inline-flex;
  padding: 0px 16px;
  font-size: 17px;
  align-self: flex-start;
  min-height: auto;
  align-items: center;
  font-family: "Open Sans Regular", arial;
  white-space: nowrap;
  border-radius: 16px;
  transition-duration: 0.175s;
  transition-property: background-color;
  transition-timing-function: ease-in-out;
}

/*blog tile design independent*/
.three-col {
  padding: 2rem 3rem;
}

.blog-tile {
  position: relative;
  max-height: 400px;
  height: 100%;
  margin: 0px;
  padding: 0px 15px;
  box-shadow: none;
  overflow: hidden;
}
.blog-tile .image-wrap img {
  width: auto;
  height: 100%;
}
.blog-tile .text-wrap {
  position: absolute;
  bottom: 0px;
  width: calc(100% - 15px);
  padding: 20px;
  background: rgba(79, 83, 96, 0.8);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
  transition: all 0.2s linear;
}
.blog-tile .text-wrap h5 {
  color: #fff !important;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.blog-tile .text-wrap .days {
  border: 0px;
  padding: 0px;
  margin-bottom: 10px;
}
.blog-tile .text-wrap .days p {
  border: 0px;
  color: #fff !important;
  text-align: left;
  font-size: 12px !important;
  width: 100%;
  margin-bottom: 0px !important;
  display: block;
}
.blog-tile .text-wrap .days p span {
  font-size: 12px;
}
.blog-tile .text-wrap .days p span i {
  margin-right: 5px;
  color: #ff8f23;
}
.blog-tile .text-wrap .days .txt p {
  margin-bottom: 0px !important;
}
.blog-tile .text-wrap .link-btn a {
  color: #fff;
}
.blog-tile:hover .text-wrap {
  padding: 30px 20px !important;
  transition: all 0.2s linear;
}

.resource-hub h6 {
  color: #fff !important;
}

.position-set {
  left: 20px !important;
}

br {
  display: none;
}

/*blog internal page setting*/
p {
  text-align: left !important;
}

.homeblog {
  padding: 15px 30px !important;
  padding: 0px !important;
}

.hashcategory {
  display: flex;
  padding: 0px;
  margin: 0px;
  list-style: none;
  align-self: flex-start;
  flex-wrap: wrap;
  padding-right: 12px;
  padding-left: 0px !important;
}

.hashcategory li {
  padding: 10px;
  border: 1px solid #ff8f23;
  border-radius: 18px;
  display: block;
  margin: 0 12px 12px 0;
}

.card-handler {
  padding-bottom: 0px;
  padding-top: 10px !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
}

.handler {
  width: 100%;
  margin-bottom: 10px;
}

.author-details {
  text-align: left;
}

.author-details p {
  padding: 0px;
  margin-bottom: 15px !important;
  text-align: left;
}

.author-details p:first-child span {
  font-weight: bold;
}

.author-details p:last-child {
  margin-bottom: 0px !important;
  border-top: 1px solid #c4c5ca;
  border-bottom: 1px solid #c4c5ca;
  padding: 10px 0px;
  display: inline-block;
  max-width: 400px;
  width: 100%;
}

.handler {
  width: 100%;
  margin-bottom: 10px;
}

ul.disc {
  margin: 0px;
  padding: 0px;
}

ul.disc li {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  padding-left: 20px;
  text-align: left;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 16px !important;
}

ul.disc li:last-child {
  margin-bottom: 0px;
}

ul.disc li:before {
  content: "";
  width: 8px;
  height: 8px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  background: #000;
  position: absolute;
  top: 10px;
  left: 0px;
}

.card-handler img {
  width: 100%;
  display: block;
  transition: all 0.5s linear;
  max-height: 250px;
  height: 100%;
  object-fit: contain;
}

/* Align blogs grid/cards to search page structure */
.video-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 0;
  width: 100%;
}

.item {
  background-color: transparent;
  border-radius: 12px;
  overflow: hidden; /* Keep hidden for thumbnail clipping */
  transition: transform 0.2s, border-radius 0.2s;
  cursor: pointer;
}

.item:hover {
  transform: translateY(-2px);
}

.video-thumbnail {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background-color: #f5f5f5;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
  transition: border-radius 0.2s;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: border-radius 0.2s;
}

.video-info {
  display: flex;
  gap: 10px;
  padding: 0 8px 8px 8px; /* Add padding to prevent text cutoff at rounded corners */
}

.video-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.video-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  justify-content: space-between;
}

.video-title {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin: 0;
  margin-bottom: 0 !important;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.meta-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  font-size: 12px;
  color: #606060;
  margin: 0;
  line-height: 1.3;
}

.channel-name {
  font-size: 13px;
  color: #606060;
  margin: 0;
}

.video-views {
  margin: 0;
}

.meta-next-line {
  display: block;
}

/* Skeletons similar to search */
.skeleton-item {
  border-radius: 12px;
}

.skeleton-media {
  width: 100%;
  aspect-ratio: 16/9;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 12px;
  margin-bottom: 12px;
}

.skeleton-text {
  height: 16px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-text.title {
  width: 80%;
}

.skeleton-text.subtitle {
  width: 60%;
  height: 14px;
}

.skeleton-user {
  display: flex;
  align-items: center;
  gap: 8px;
}

.skeleton-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@media (max-width: 1024px) {
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .video-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
/* Card edge behaviors - square corners on hover for desktop */
@media (min-width: 993px) {
  /* Desktop: square edge on hover */
  .item:hover {
    border-radius: 0 !important;
  }
  .item:hover .video-thumbnail {
    border-radius: 0 !important;
  }
  .item:hover .thumbnail-image {
    border-radius: 0 !important;
  }
}
@media (max-width: 767px) {
  /* Mobile: full-width with square edges */
  .item,
  .video-thumbnail {
    border-radius: 0 !important;
  }
}
/* Skeleton card wrapper spacing to match real cards */
.skeleton-card {
  margin-bottom: 24px;
}

section {
  background: #ffffff !important;
  padding: 50px 0 40px;
}

.btn-position .position-set {
  position: absolute !important;
  bottom: 1rem !important;
  left: 1rem !important;
  width: calc(100% - 2rem);
}
.btn-position .position-set a {
  color: #5ea1d8 !important;
}

h6 {
  font-weight: bold !important;
}

/*add search bar*/
.categories {
  padding-bottom: 0px !important;
}

.categories .serach-bar {
  display: flex;
  margin: 0px auto;
  align-items: center;
  position: relative;
  justify-content: space-between;
  max-width: 900px;
  gap: 20px;
  padding: 20px 0px;
}

.categories .serach-bar .search-input-wrap {
  position: relative;
  flex: 1;
  order: 2;
  min-width: 220px;
}

.categories .serach-bar .search-input-wrap input {
  border: 1px solid #ddd !important;
  border-radius: 10px;
  height: 50px;
  margin-right: 0px !important;
  padding-left: 12px !important;
  padding-right: 88px !important;
  font-size: 18px;
  font-weight: normal;
  text-align: left !important;
  color: #212427 !important;
  margin: 0px 0px 0px 0px !important;
  width: 100% !important;
  background: transparent;
  outline: none;
  box-sizing: border-box;
}

.categories .serach-bar .search-icon-button,
.categories .serach-bar .cancel-icon-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  -webkit-appearance: none;
  color: #666666;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
  border-radius: 50%;
  z-index: 1;
}

.categories .serach-bar .search-icon-button {
  right: 8px;
}

.categories .serach-bar .cancel-icon-button {
  right: 44px;
}

.categories .serach-bar .search-icon-button:hover,
.categories .serach-bar .cancel-icon-button:hover {
  color: #000000;
  background-color: #f0f0f0;
}

.categories .serach-bar .search-icon-button mat-icon,
.categories .serach-bar .cancel-icon-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.img-div-left1 {
  position: absolute;
  right: 0px;
  top: 20px;
}
.img-div-left1 img {
  position: relative;
  top: 0px;
  width: 50px;
}

/*sticky footer design*/
@media screen and (max-width: 992px) {
  .div1 {
    display: none !important; /* Hide footer on mobile view */
    height: 50px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    overflow: hidden;
    z-index: 1;
  }
  .foot-ico {
    width: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    height: 100%;
    border-top: 1px solid lightgray;
  }
  .foot-ico ul {
    display: flex;
    list-style: none;
    align-items: center;
    justify-content: center;
    margin: 0px;
    width: 100%;
    margin: 0px auto;
    padding: 0px;
  }
  .foot-ico ul li {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .foot-ico ul li {
    margin: 0px;
    width: 25px;
    height: 25px;
    flex: 1;
    display: flex;
    justify-content: center;
  }
  .foot-ico ul li span {
    text-align: center;
    display: block;
    width: 100%;
    text-align: center;
  }
  .foot-ico ul li span {
    text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
    font-size: 25px;
  }
  .foot-ico ul li .icon-text {
    text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
    font-size: 12px;
    color: gray;
    display: block;
    text-align: center;
    font-family: "Raleway" !important;
  }
  .foot-ico {
    width: 100%;
    margin: 0px auto;
    display: flex;
    align-items: flex-start !important;
    height: 100%;
    border-top: 1px solid lightgray;
    padding-top: 5px !important;
  }
  .foot-ico ul {
    display: flex;
    list-style: none;
    align-items: center;
    justify-content: center;
    margin: 0px;
    width: 100%;
    margin: 0px auto;
    padding: 0px;
  }
  .foot-ico ul li {
    margin: 0px;
    width: 25px;
    flex: 1;
    display: flex;
    justify-content: center;
  }
}
.create-blog-btn {
  padding: 10px 15px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  border-radius: 35px;
  order: 3;
  display: flex;
  align-items: center;
  height: 50px;
  gap: 6px;
  background-color: #ffffff;
  color: #111827;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.create-blog-btn:hover {
  background-color: #f8fafc;
  color: #111827;
}

.create-blog-btn.disabled {
  color: #6b7280;
}

.filter-btn {
  padding: 0px;
  border: none;
  cursor: pointer;
  border-radius: 35px;
  order: 4;
}

.filter-btn:hover {
  background-color: white;
  color: #000;
}

.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px; /* Space between text and icon */
  font-size: 16px;
  color: #555;
}

.add-icon {
  cursor: pointer;
  color: #5ea1d8; /* Icon color */
  font-size: 24px;
  transition: transform 0.2s;
}

.add-icon:hover {
  transform: scale(1.2); /* Slight zoom effect */
  color: #3d82c3; /* Darker shade on hover */
}

@media (max-width: 767px) {
  .categories {
    padding-left: 20px;
    padding-right: 20px;
  }
  .categories .serach-bar {
    flex-wrap: wrap;
  }
  .categories .serach-bar .search-input-wrap {
    width: 100%;
    flex: unset;
  }
  .categories .serach-bar .search-input-wrap input {
    width: 100% !important;
  }
  .categories .create-blog-btn {
    flex: 1;
  }
  .categories .filter-btn {
    flex: 1;
  }
  .categories .serach-bar .search-icon-button,
  .categories .serach-bar .cancel-icon-button {
    top: 50% !important;
  }
}
/* Keep /bulbguide skeleton + button readable in dark mode */
:host-context(body.theme-dark) .categories,
:host-context(body.theme-dark) section {
  background: #0a0c10 !important;
}
:host-context(body.theme-dark) .categories .serach-bar .search-input-wrap input {
  background: #111827 !important;
  border-color: #334155 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .categories .serach-bar .search-icon-button,
:host-context(body.theme-dark) .categories .serach-bar .cancel-icon-button {
  color: #94a3b8;
}
:host-context(body.theme-dark) .categories .serach-bar .search-icon-button:hover,
:host-context(body.theme-dark) .categories .serach-bar .cancel-icon-button:hover {
  color: #e5e7eb;
  background-color: #1f2937;
}
:host-context(body.theme-dark) .create-blog-btn {
  background-color: #111827;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .create-blog-btn:hover {
  background-color: #1f2937;
  color: #f8fafc;
}
:host-context(body.theme-dark) .create-blog-btn.disabled {
  color: #94a3b8;
  border-color: #334155;
}
:host-context(body.theme-dark) .video-title {
  color: #f8fafc;
}
:host-context(body.theme-dark) .meta-row,
:host-context(body.theme-dark) .video-views,
:host-context(body.theme-dark) .center-content {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .video-thumbnail {
  background-color: #111827;
}
:host-context(body.theme-dark) .skeleton-media,
:host-context(body.theme-dark) .skeleton-text,
:host-context(body.theme-dark) .skeleton-avatar {
  background: linear-gradient(90deg, #1f2937 25%, #334155 50%, #1f2937 75%);
  background-size: 200% 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/blogs/blogs.component.scss"],"names":[],"mappings":"AAAA,gBAAA;AACA;EACE,2BAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AACI;EACE,YAAA;EACA,6BAAA;EACA,0BAAA;EACA,eAAA;AACN;AAEI;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AAAN;AAGI;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;AADN;AAKE;EACE,aAAA;EACA,OAAA;EAEA,wBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AAJJ;AAMI;EACE,OAAA;EACA,kBAAA;AAJN;AAMM;EACE,WAAA;AAJR;AAMQ;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAJV;AAQU;EACE,kBAAA;AANZ;AAYI;EACE,OAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EAEA,2BAAA;AAXN;AAaM;EACE,UAAA;EACA,YAAA;EACA,iCAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAXR;AAgBE;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AAdJ;AAgBI;EACE,yBAAA;EACA,oBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAdN;AAgBM;EACE,yBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;AAdR;;AAoBA,+BAAA;AACA;EACE,kBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAjBF;AAoBI;EACE,WAAA;EACA,YAAA;AAlBN;AAsBE;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,aAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,2BAAA;AApBJ;AAsBI;EACE,sBAAA;EAEA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AArBN;AAwBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAtBN;AAwBM;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;EACA,6BAAA;EAWA,cAAA;AAhCR;AAuBQ;EACE,eAAA;AArBV;AAuBU;EACE,iBAAA;EACA,cAAA;AArBZ;AA6BQ;EACE,6BAAA;AA3BV;AAiCM;EACE,WAAA;AA/BR;AAqCI;EACE,6BAAA;EACA,2BAAA;AAnCN;;AAwCA;EACE,sBAAA;AArCF;;AAwCA;EACE,qBAAA;AArCF;;AAwCA;EACE,aAAA;AArCF;;AAwCA,6BAAA;AACA;EACE,2BAAA;AArCF;;AAwCA;EACE,6BAAA;EACA,uBAAA;AArCF;;AAwCA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;AArCF;;AAwCA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AArCF;;AAwCA;EACE,mBAAA;EACA,4BAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EAEA,WAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,mBAAA;AAtCF;;AAyCA;EACE,gBAAA;AAtCF;;AAyCA;EACE,YAAA;EACA,8BAAA;EACA,gBAAA;AAtCF;;AAyCA;EACE,iBAAA;AAtCF;;AAyCA;EACE,6BAAA;EACA,6BAAA;EACA,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,mBAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,YAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;AAtCF;;AAyCA;EACE,kBAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,cAAA;EACA,2BAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AAtCF;;AAyCA,oDAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAtCF;;AAyCA;EACE,6BAAA;EACA,mBAAA;EACA,gBAAA,EAAA,uCAAA;EACA,8CAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,2BAAA;AAtCF;;AAyCA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,SAAA;EACA,sBAAA,EAAA,0DAAA;AAtCF;;AAyCA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAtCF;;AAyCA;EACE,SAAA;AAtCF;;AAyCA;EACE,cAAA;AAtCF;;AAyCA,gCAAA;AACA;EACE,mBAAA;AAtCF;;AAwCA;EACE,WAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;AArCF;;AAuCA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;AApCF;;AAsCA;EACE,UAAA;AAnCF;;AAqCA;EACE,UAAA;EACA,YAAA;AAlCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjCF;;AAmCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;AAhCF;;AAmCA;EACE;IACE,4BAAA;EAhCF;EAkCA;IACE,2BAAA;EAhCF;AACF;AAmCA;EACE;IACE,qCAAA;EAjCF;AACF;AAoCA;EACE;IACE,0BAAA;IACA,SAAA;EAlCF;AACF;AAqCA,8DAAA;AACA;EACE,kCAAA;EACA;IACE,2BAAA;EAnCF;EAqCA;IACE,2BAAA;EAnCF;EAqCA;IACE,2BAAA;EAnCF;AACF;AAsCA;EACE,yCAAA;EACA;;IAEE,2BAAA;EApCF;AACF;AAuCA,sDAAA;AACA;EACE,mBAAA;AArCF;;AAwCA;EACE,8BAAA;EACA,oBAAA;AArCF;;AAyCE;EACE,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;AAtCJ;AAwCI;EACE,yBAAA;AAtCN;;AA2CA;EACE,4BAAA;AAxCF;;AA2CA,iBAAA;AACA;EACE,8BAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;AAxCF;;AA2CA;EACE,iCAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAxCF;;AA2CA;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6CAAA;EACA,kBAAA;EACA,UAAA;AAxCF;;AA2CA;EACE,UAAA;AAxCF;;AA2CA;EACE,WAAA;AAxCF;;AA2CA;;EAEE,cAAA;EACA,yBAAA;AAxCF;;AA2CA;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAxCF;AA0CE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AAxCJ;;AAiEA,uBAAA;AACA;EACE;IACE,wBAAA,EAAA,+BAAA;IACA,YAAA;IACA,eAAA;IACA,OAAA;IACA,SAAA;IACA,WAAA;IACA,uBAAA;IACA,gBAAA;IACA,UAAA;EA9DF;EAiEA;IACE,WAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,YAAA;IACA,+BAAA;EA/DF;EAkEA;IACE,aAAA;IACA,gBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;EAhEF;EAmEA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EAjEF;EAoEA;IACE,WAAA;IACA,WAAA;IACA,YAAA;IACA,OAAA;IACA,aAAA;IACA,uBAAA;EAlEF;EAqEA;IACE,kBAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;EAnEF;EAsEA;IACE,iDAAA;IACA,eAAA;EApEF;EAuEA;IACE,iDAAA;IACA,eAAA;IACA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,iCAAA;EArEF;EAwEA;IACE,WAAA;IACA,gBAAA;IACA,aAAA;IACA,kCAAA;IACA,YAAA;IACA,+BAAA;IACA,2BAAA;EAtEF;EAyEA;IACE,aAAA;IACA,gBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;EAvEF;EA0EA;IACE,WAAA;IACA,WAAA;IACA,OAAA;IACA,aAAA;IACA,uBAAA;EAxEF;AACF;AA2EA;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,+EAAA;AAzEF;;AA4EA;EACE,yBAAA;EACA,cAAA;AAzEF;;AA4EA;EACE,cAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EAKA,QAAA;AA7EF;;AAgFA;EACE,uBAAA;EACA,WAAA;AA7EF;;AA+EA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA,EAAA,gCAAA;EACA,eAAA;EACA,WAAA;AA5EF;;AA+EA;EACE,eAAA;EACA,cAAA,EAAA,eAAA;EACA,eAAA;EACA,0BAAA;AA5EF;;AA+EA;EACE,qBAAA,EAAA,uBAAA;EACA,cAAA,EAAA,0BAAA;AA5EF;;AAgGA;EACE;IACE,kBAAA;IACA,mBAAA;EA7FF;EA8FE;IACE,eAAA;EA5FJ;EA6FI;IACE,WAAA;IACA,WAAA;EA3FN;EA6FI;IACE,sBAAA;EA3FN;EA8FE;IACE,OAAA;EA5FJ;EA8FE;IACE,OAAA;EA5FJ;EA8FE;;IAEE,mBAAA;EA5FJ;AACF;AAgGA,4DAAA;AAEE;;EAEE,8BAAA;AA/FJ;AAkGE;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAhGJ;AAmGE;;EAEE,cAAA;AAjGJ;AAoGE;;EAEE,cAAA;EACA,yBAAA;AAlGJ;AAqGE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAnGJ;AAsGE;EACE,yBAAA;EACA,cAAA;AApGJ;AAuGE;EACE,cAAA;EACA,qBAAA;AArGJ;AAwGE;EACE,cAAA;AAtGJ;AAyGE;;;EAGE,cAAA;AAvGJ;AA0GE;EACE,yBAAA;AAxGJ;AA2GE;;;EAGE,yEAAA;EACA,0BAAA;AAzGJ","sourcesContent":["/* resource hub*/\n.resource-hub {\n  background: #fff !important;\n  padding: 2rem 3rem;\n\n  .search-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    border: 0px;\n    border-bottom: 1px solid #212529;\n    border-radius: 0px;\n    padding: 5px;\n    margin-bottom: 20px;\n    background: transparent;\n    height: 60px;\n\n    .search-icon {\n      padding: 5px;\n      background-color: transparent;\n      border-radius: 5px 0 0 5px;\n      font-size: 20px;\n    }\n\n    .search-input {\n      flex: 1;\n      border: none;\n      padding: 5px;\n      height: 100%;\n      font-size: 25px;\n      font-weight: 400;\n      background: transparent;\n      outline: none !important;\n    }\n\n    .search-button {\n      padding: 5px 10px;\n      background-color: #007bff;\n      color: #fff;\n      border: none;\n      border-radius: 0 5px 5px 0;\n      cursor: pointer;\n      display: none;\n    }\n  }\n\n  .serch-topic-module {\n    display: flex;\n    flex: 1;\n    // position: absolute;\n    width: calc(100% - 24px);\n    bottom: 0px;\n    right: 30px;\n    left: 12px;\n\n    .module-wrap {\n      flex: 1;\n      margin-right: 20px;\n\n      .module-parent {\n        width: 100%;\n\n        button {\n          align-items: center;\n          background-color: #ebebed;\n          box-sizing: border-box;\n          cursor: pointer;\n          display: flex;\n          font-size: 20px;\n          height: 100%;\n          letter-spacing: -0.1px;\n          padding: 26px 32px 27px;\n          text-align: left;\n          width: 100%;\n          border: 0px;\n          margin-bottom: 20px;\n          font-size: 19px;\n          padding: 23px 28px;\n          display: flex;\n          justify-content: space-between;\n        }\n\n        &:last-child {\n          button {\n            margin-bottom: 0px;\n          }\n        }\n      }\n    }\n\n    .searchbtn-wrap {\n      flex: 1;\n      width: auto;\n      display: flex;\n      align-items: end;\n\n      justify-content: flex-start;\n\n      button {\n        width: 80%;\n        height: 80px;\n        background: rgba(79, 83, 96, 0.8);\n        border-radius: 45px;\n        color: #fff;\n        font-size: 19px;\n        border: 0px;\n        padding: 23px 28px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n      }\n    }\n  }\n\n  .module-details {\n    position: fixed;\n    width: 100%;\n    max-height: 400px;\n    display: none;\n\n    ul {\n      border: 1px solid #c4c5ca;\n      display: inline-flex;\n      padding: 15px !important;\n      flex-wrap: wrap;\n      min-width: 100%;\n      box-sizing: border-box;\n\n      li {\n        border: 1px solid #ebebed;\n        cursor: pointer;\n        height: 36px;\n        margin: 8px;\n        display: inline-flex;\n        padding: 0px 16px;\n        font-size: 17px;\n        align-self: flex-start;\n        min-height: auto;\n        align-items: center;\n        font-family: \"Open Sans Regular\", arial;\n        white-space: nowrap;\n        border-radius: 16px;\n        transition-duration: 0.175s;\n        transition-property: background-color;\n        transition-timing-function: ease-in-out;\n      }\n    }\n  }\n}\n\n/*blog tile design independent*/\n.three-col {\n  padding: 2rem 3rem;\n}\n\n.blog-tile {\n  position: relative;\n  max-height: 400px;\n  height: 100%;\n  margin: 0px;\n  padding: 0px 15px;\n  box-shadow: none;\n  overflow: hidden;\n\n  .image-wrap {\n    img {\n      width: auto;\n      height: 100%;\n    }\n  }\n\n  .text-wrap {\n    position: absolute;\n    bottom: 0px;\n    width: calc(100% - 15px);\n    padding: 20px;\n    background: rgba(79, 83, 96, 0.8);\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    justify-content: flex-end;\n    transition: all 0.2s linear;\n\n    h5 {\n      color: #fff !important;\n\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n\n    .days {\n      border: 0px;\n      padding: 0px;\n      margin-bottom: 10px;\n\n      p {\n        border: 0px;\n        color: #fff !important;\n        text-align: left;\n        font-size: 12px !important;\n        width: 100%;\n        margin-bottom: 0px !important;\n\n        span {\n          font-size: 12px;\n\n          i {\n            margin-right: 5px;\n            color: #ff8f23;\n          }\n        }\n\n        display: block;\n      }\n\n      .txt {\n        p {\n          margin-bottom: 0px !important;\n        }\n      }\n    }\n\n    .link-btn {\n      a {\n        color: #fff;\n      }\n    }\n  }\n\n  &:hover {\n    .text-wrap {\n      padding: 30px 20px !important;\n      transition: all 0.2s linear;\n    }\n  }\n}\n\n.resource-hub h6 {\n  color: #fff !important;\n}\n\n.position-set {\n  left: 20px !important;\n}\n\nbr {\n  display: none;\n}\n\n/*blog internal page setting*/\np {\n  text-align: left !important;\n}\n\n.homeblog {\n  padding: 15px 30px !important;\n  padding: 0px !important;\n}\n\n.hashcategory {\n  display: flex;\n  padding: 0px;\n  margin: 0px;\n  list-style: none;\n  align-self: flex-start;\n  flex-wrap: wrap;\n  padding-right: 12px;\n  padding-left: 0px !important;\n}\n\n.hashcategory li {\n  padding: 10px;\n  border: 1px solid #ff8f23;\n  border-radius: 18px;\n  display: block;\n  margin: 0 12px 12px 0;\n}\n\n.card-handler {\n  padding-bottom: 0px;\n  padding-top: 10px !important;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  width: 100%;\n}\n\n.handler {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.author-details {\n  text-align: left;\n}\n\n.author-details p {\n  padding: 0px;\n  margin-bottom: 15px !important;\n  text-align: left;\n}\n\n.author-details p:first-child span {\n  font-weight: bold;\n}\n\n.author-details p:last-child {\n  margin-bottom: 0px !important;\n  border-top: 1px solid #c4c5ca;\n  border-bottom: 1px solid #c4c5ca;\n  padding: 10px 0px;\n  display: inline-block;\n  max-width: 400px;\n  width: 100%;\n}\n\n.handler {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\nul.disc {\n  margin: 0px;\n  padding: 0px;\n}\n\nul.disc li {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  position: relative;\n  padding-left: 20px;\n  text-align: left;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 16px !important;\n}\n\nul.disc li:last-child {\n  margin-bottom: 0px;\n}\n\nul.disc li:before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  aspect-ratio: 1/1;\n  border-radius: 50%;\n  background: #000;\n  position: absolute;\n  top: 10px;\n  left: 0px;\n}\n\n.card-handler img {\n  width: 100%;\n  display: block;\n  transition: all 0.5s linear;\n  max-height: 250px;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* Align blogs grid/cards to search page structure */\n.video-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  padding: 0;\n  width: 100%;\n}\n\n.item {\n  background-color: transparent;\n  border-radius: 12px;\n  overflow: hidden; /* Keep hidden for thumbnail clipping */\n  transition: transform 0.2s, border-radius 0.2s;\n  cursor: pointer;\n}\n\n.item:hover {\n  transform: translateY(-2px);\n}\n\n.video-thumbnail {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16/9;\n  background-color: #f5f5f5;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 12px;\n  transition: border-radius 0.2s;\n}\n\n.thumbnail-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: border-radius 0.2s;\n}\n\n.video-info {\n  display: flex;\n  gap: 10px;\n  padding: 0 8px 8px 8px; /* Add padding to prevent text cutoff at rounded corners */\n}\n\n.video-details {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.video-title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  justify-content: space-between;\n}\n\n.video-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n  margin: 0;\n  margin-bottom: 0 !important;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.meta-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  font-size: 12px;\n  color: #606060;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.channel-name {\n  font-size: 13px;\n  color: #606060;\n  margin: 0;\n}\n\n.video-views {\n  margin: 0;\n}\n\n.meta-next-line {\n  display: block;\n}\n\n/* Skeletons similar to search */\n.skeleton-item {\n  border-radius: 12px;\n}\n.skeleton-media {\n  width: 100%;\n  aspect-ratio: 16/9;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 12px;\n  margin-bottom: 12px;\n}\n.skeleton-text {\n  height: 16px;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n.skeleton-text.title {\n  width: 80%;\n}\n.skeleton-text.subtitle {\n  width: 60%;\n  height: 14px;\n}\n.skeleton-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.skeleton-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@media (max-width: 1024px) {\n  .video-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .video-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n\n/* Card edge behaviors - square corners on hover for desktop */\n@media (min-width: 993px) {\n  /* Desktop: square edge on hover */\n  .item:hover {\n    border-radius: 0 !important;\n  }\n  .item:hover .video-thumbnail {\n    border-radius: 0 !important;\n  }\n  .item:hover .thumbnail-image {\n    border-radius: 0 !important;\n  }\n}\n\n@media (max-width: 767px) {\n  /* Mobile: full-width with square edges */\n  .item,\n  .video-thumbnail {\n    border-radius: 0 !important;\n  }\n}\n\n/* Skeleton card wrapper spacing to match real cards */\n.skeleton-card {\n  margin-bottom: 24px;\n}\n\nsection {\n  background: #ffffff !important;\n  padding: 50px 0 40px;\n}\n\n.btn-position {\n  .position-set {\n    position: absolute !important;\n    bottom: 1rem !important;\n    left: 1rem !important;\n    width: calc(100% - 2rem);\n\n    a {\n      color: #5ea1d8 !important;\n    }\n  }\n}\n\nh6 {\n  font-weight: bold !important;\n}\n\n/*add search bar*/\n.categories {\n  padding-bottom: 0px !important;\n}\n\n.categories .serach-bar {\n  display: flex;\n  margin: 0px auto;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n  max-width: 900px;\n  gap: 20px;\n  padding: 20px 0px;\n}\n\n.categories .serach-bar .search-input-wrap {\n  position: relative;\n  flex: 1;\n  order: 2;\n  min-width: 220px;\n}\n\n.categories .serach-bar .search-input-wrap input {\n  border: 1px solid #ddd !important;\n  border-radius: 10px;\n  height: 50px;\n  margin-right: 0px !important;\n  padding-left: 12px !important;\n  padding-right: 88px !important;\n  font-size: 18px;\n  font-weight: normal;\n  text-align: left !important;\n  color: #212427 !important;\n  margin: 0px 0px 0px 0px !important;\n  width: 100% !important;\n  background: transparent;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.categories .serach-bar .search-icon-button,\n.categories .serach-bar .cancel-icon-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  -webkit-appearance: none;\n  color: #666666;\n  padding: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s, background-color 0.2s;\n  border-radius: 50%;\n  z-index: 1;\n}\n\n.categories .serach-bar .search-icon-button {\n  right: 8px;\n}\n\n.categories .serach-bar .cancel-icon-button {\n  right: 44px;\n}\n\n.categories .serach-bar .search-icon-button:hover,\n.categories .serach-bar .cancel-icon-button:hover {\n  color: #000000;\n  background-color: #f0f0f0;\n}\n\n.categories .serach-bar .search-icon-button mat-icon,\n.categories .serach-bar .cancel-icon-button mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.img-div-left1 {\n  position: absolute;\n  right: 0px;\n  top: 20px;\n\n  img {\n    position: relative;\n    top: 0px;\n    width: 50px;\n  }\n}\n\n// .button1{\n//   background-color: white;\n//   color: black;\n//   border: 1px solid lightgrey;\n//   color: #212427 !important;\n// }\n// .button{\n//   background-color: #4caf50;\n//   width: 99px;\n//   height: 57px;\n//   margin-left: 0px;\n//   font-size: 16px;\n//   transition-duration: 0.4s;\n//   cursor: pointer;\n//   border-radius: 10px;\n// }\n// @media (max-width: 992px) {\n//   .categories {\n//       padding: 0px 20px !important;\n//   }\n// }\n/*sticky footer design*/\n@media screen and (max-width: 992px) {\n  .div1 {\n    display: none !important; /* Hide footer on mobile view */\n    height: 50px;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background-color: white;\n    overflow: hidden;\n    z-index: 1;\n  }\n\n  .foot-ico {\n    width: 100%;\n    margin: 0px auto;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    border-top: 1px solid lightgray;\n  }\n\n  .foot-ico ul {\n    display: flex;\n    list-style: none;\n    align-items: center;\n    justify-content: center;\n    margin: 0px;\n    width: 100%;\n    margin: 0px auto;\n    padding: 0px;\n  }\n\n  .foot-ico ul li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .foot-ico ul li {\n    margin: 0px;\n    width: 25px;\n    height: 25px;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n  }\n\n  .foot-ico ul li span {\n    text-align: center;\n    display: block;\n    width: 100%;\n    text-align: center;\n  }\n\n  .foot-ico ul li span {\n    text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);\n    font-size: 25px;\n  }\n\n  .foot-ico ul li .icon-text {\n    text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);\n    font-size: 12px;\n    color: gray;\n    display: block;\n    text-align: center;\n    font-family: \"Raleway\" !important;\n  }\n\n  .foot-ico {\n    width: 100%;\n    margin: 0px auto;\n    display: flex;\n    align-items: flex-start !important;\n    height: 100%;\n    border-top: 1px solid lightgray;\n    padding-top: 5px !important;\n  }\n\n  .foot-ico ul {\n    display: flex;\n    list-style: none;\n    align-items: center;\n    justify-content: center;\n    margin: 0px;\n    width: 100%;\n    margin: 0px auto;\n    padding: 0px;\n  }\n\n  .foot-ico ul li {\n    margin: 0px;\n    width: 25px;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.create-blog-btn {\n  padding: 10px 15px;\n  border: 1px solid #d1d5db;\n  cursor: pointer;\n  border-radius: 35px;\n  order: 3;\n  display: flex;\n  align-items: center;\n  height: 50px;\n  gap: 6px;\n  background-color: #ffffff;\n  color: #111827;\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.create-blog-btn:hover {\n  background-color: #f8fafc;\n  color: #111827;\n}\n\n.create-blog-btn.disabled {\n  color: #6b7280;\n}\n\n.filter-btn {\n  padding: 0px;\n  border: none;\n  cursor: pointer;\n  border-radius: 35px;\n\n  // position: absolute;\n  // right: -120px;\n  // top: 22px;\n  order: 4;\n}\n\n.filter-btn:hover {\n  background-color: white;\n  color: #000;\n}\n.center-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px; /* Space between text and icon */\n  font-size: 16px;\n  color: #555;\n}\n\n.add-icon {\n  cursor: pointer;\n  color: #5ea1d8; /* Icon color */\n  font-size: 24px;\n  transition: transform 0.2s;\n}\n\n.add-icon:hover {\n  transform: scale(1.2); /* Slight zoom effect */\n  color: #3d82c3; /* Darker shade on hover */\n}\n//   cursor: pointer;\n//   display: grid;\n//  justify-content: center; /* Centers both horizontally & vertically */\n// }\n\n// .add-icon {\n//   cursor: pointer;\n//   display: grid;\n//   justify-content: center;\n//   color: #5ea1d8; /* Change color */\n//   font-size: 24px;\n//   transition: transform 0.2s;\n// }\n\n// .add-icon:hover {\n//   transform: scale(1.2); /* Slight zoom effect */\n//   color: #3d82c3; /* Darker shade on hover */\n// }\n@media (max-width: 767px) {\n  .categories {\n    padding-left: 20px;\n    padding-right: 20px;\n    .serach-bar {\n      flex-wrap: wrap;\n      .search-input-wrap {\n        width: 100%;\n        flex: unset;\n      }\n      .search-input-wrap input {\n        width: 100% !important;\n      }\n    }\n    .create-blog-btn {\n      flex: 1;\n    }\n    .filter-btn {\n      flex: 1;\n    }\n    .serach-bar .search-icon-button,\n    .serach-bar .cancel-icon-button {\n      top: 50% !important;\n    }\n  }\n}\n\n/* Keep /bulbguide skeleton + button readable in dark mode */\n:host-context(body.theme-dark) {\n  .categories,\n  section {\n    background: #0a0c10 !important;\n  }\n\n  .categories .serach-bar .search-input-wrap input {\n    background: #111827 !important;\n    border-color: #334155 !important;\n    color: #e5e7eb !important;\n  }\n\n  .categories .serach-bar .search-icon-button,\n  .categories .serach-bar .cancel-icon-button {\n    color: #94a3b8;\n  }\n\n  .categories .serach-bar .search-icon-button:hover,\n  .categories .serach-bar .cancel-icon-button:hover {\n    color: #e5e7eb;\n    background-color: #1f2937;\n  }\n\n  .create-blog-btn {\n    background-color: #111827;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .create-blog-btn:hover {\n    background-color: #1f2937;\n    color: #f8fafc;\n  }\n\n  .create-blog-btn.disabled {\n    color: #94a3b8;\n    border-color: #334155;\n  }\n\n  .video-title {\n    color: #f8fafc;\n  }\n\n  .meta-row,\n  .video-views,\n  .center-content {\n    color: #cbd5e1;\n  }\n\n  .video-thumbnail {\n    background-color: #111827;\n  }\n\n  .skeleton-media,\n  .skeleton-text,\n  .skeleton-avatar {\n    background: linear-gradient(90deg, #1f2937 25%, #334155 50%, #1f2937 75%);\n    background-size: 200% 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
